// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"64":"f5fd4b49f5eb390f0d83","223":"d24bd9fc14e0f30d8f75","463":"1719994fb72dbfebf4f6"}[chunkId] + ".css";
};